/*-- import aliases -----------
'!/...' -> project root
'~/...' -> js folder root
-----------------------------*/
import { setup } from "~/core";
setup();

import "~/global/_body";
import "~/global/_header";
import "~/global/_footer";
import "~/global/_siteModals";
import "~/global/_alert";
import "~/global/_liveChatDismiss";
import "~/global/_imgSwap";

import "~/components/_accordion";
import "~/components/_forms";
import "~/components/_cookieConsent";
import "~/components/_locationDetail";
import "~/components/_locationFinder";
import "~/components/_locationsMap";
import "~/components/_nav";
import "~/components/_searchHeader";
import "~/components/_supplierInfo";
import "~/components/_tagFilters";
import "~/components/_testimonial";
